import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 9"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      transform: "translate(.67 .67)"
    }, [
      createElementVNode("rect", { transform: "rotate(180 4 4)" }),
      createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": ".5",
        d: "M2.85 1.73h3.4v3.4m0-3.4L1.74 6.24"
      })
    ], -1)
  ]));
}
const ExternalLink = { render };
export {
  ExternalLink as default,
  render
};
//# sourceMappingURL=ExternalLink.svg.js.map
